import React from 'react';
import * as ReactDOM from "react-dom";
import {withRouter} from "../withRouter";
import {NavLink} from "react-router-dom";
import ModeratorGames from "./ModeratorGames";
import {Col, Container, Row} from "react-bootstrap";

class PublisherGameActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            loginError: null,
            allActions: [],
            actions: []
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    if (result.role.name !== 'moderator' && result.role.name !== 'publisher' && result.role.name !== 'admin') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        });
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        error,
                    });
                }
            );

        fetch(process.env.REACT_APP_API_URL + "/publisher/company/game/"+this.props.gameId+"/actions", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        actions: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )

        fetch(process.env.REACT_APP_API_URL + "/publisher/company/game/"+this.props.gameId+"/actions/all", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        allActions: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    render() {
        const { isLoaded, loginError, error, actions, allActions  } = this.state;

        const { navigate } = this.props;

        if (loginError) {
            navigate('/account');
        }

        let content = null;

        if (isLoaded) {
            content = <div class="row">
                <div class="col-sm-6">
                    <h1>Your recent activity</h1>
                    {actions.map(item => (
                        <div class="alert alert-dark">
                            <hr/>
                            <NavLink
                                to={"/games/" + item.game_id.toString()}
                                className="btn btn-dark"
                            >
                                {item.game.name} - {item.type}
                            </NavLink>
                            <br/>
                            Fields:
                            {item.fields.map(item => (<li style={{
                                overflowX: "scroll"
                            }}>{JSON.stringify(item)}</li>))}
                        </div>
                    ))}
                </div>

                <div class="col-sm-6">
                    <h1>All activity</h1>
                    {allActions.map(item => (
                        <div class="alert alert-dark">
                            <hr/>
                            <h4>Performed by {item.performed_by}</h4>
                            <NavLink
                                to={"/games/" + item.game_id.toString()}
                                className="btn btn-dark"
                            >
                                {item.game.name} - {item.type}
                            </NavLink>
                            <br/>
                            Fields:
                            {item.fields.map(item => (<li style={{
                                overflowX: "scroll"
                            }}>{JSON.stringify(item)}</li>))}
                        </div>
                    ))}
                    <hr/>
                </div>
            </div>;
        } else {
            content = <h1>Loading...</h1>
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>
    }
}

export default withRouter(PublisherGameActivity);
